import React, { FC, ReactNode } from 'react';
import styled from '@emotion/native';
import {
  Modal,
  Activity,
  Spacer,
  Text
} from '@components/1-atoms';
import { APIData, STATE } from '@lib/constants';
import { Button } from './Buttons';

import * as utils from '@lib/utils';

const Container = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;


type Props = APIData & {
  children?: ReactNode;
  message?: string;
};

export const StatusModal: FC<Props> = ({ message, children, state, ...props }) => {

  const isVisible = (state != STATE.CANCEL) && (state != STATE.DONE);

  const [visible, setVisible] = React.useState(isVisible);
  React.useEffect(() => { setVisible(isVisible); }, [state, isVisible]);

  const _onClose = (): void => { setVisible(false); };

  if (state === STATE.ERROR) {
    return (
      <Modal closable={false} visible={visible} transparent={false} onClose={_onClose} {...props}>
        <Container>
          <Spacer />
          <Activity state={state} />
          <Spacer h={1} />
          {children || <Text xlarge>{message}</Text>}
        </Container>

        <Spacer h={1} />
        <Button onPress={utils.reloadApp}>RELOAD</Button>
        <Spacer h={2} />
      </Modal>
    );
  } else {
    return (
      <Modal closable={false} visible={visible} transparent={false} onClose={_onClose} {...props}>
        <Container>
          <Spacer />
          <Activity state={state} />
          <Spacer h={1} />
          {children || <Text xlarge>{message}</Text>}
        </Container>
      </Modal>
    );

  }

};


export default StatusModal;